// Package imports
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './FloatingDropdown.css';

// Helpers
import OutsideAlerter from '../../helpers/components/outsideAlerter/OutsideAlerter';

// Icons
import { IoChevronDown } from 'react-icons/io5';

// Types
import { DropdownElement } from '../../types/dropdown/DropdownElement';

type Props = {
  label?: string;
  customLabel?: React.ReactNode;
  elements: DropdownElement[];
  openToLeft?: boolean;
  className?: string;
};

const FloatingDropdown: React.FC<Props> = ({
  label,
  customLabel,
  elements,
  openToLeft,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <OutsideAlerter toggleEvent={toggleOpen} dependency={isOpen}>
      <div
        className={`FloatingDropdown ${className ? className : ''}`}
        ref={wrapperRef}
      >
        <div onClick={toggleOpen} className='label-container'>
          {customLabel ? (
            <div className='label'>{customLabel}</div>
          ) : (
            <span className='label'>{label ? label : 'Your label'}</span>
          )}
          <IoChevronDown
            className={`chevron ${isOpen ? 'chevron-up' : null}`}
          />
        </div>
        {isOpen ? (
          <ul className={`menu ${openToLeft ? 'open-left' : ''}`}>
            {elements.map((element: DropdownElement, index: number) => (
              <li key={index}>
                {element.isButton ? (
                  <div
                    className='link-element'
                    onClick={() => {
                      toggleOpen();
                      if (element.action !== undefined) {
                        element.action();
                      }
                    }}
                  >
                    {element.ReactIcon ? (
                      <element.ReactIcon
                        className='nav-icon'
                        color={
                          element.iconColor ? element.iconColor : '#6b3feb'
                        }
                      />
                    ) : element.imgIcon ? (
                      <img
                        className='nav-icon'
                        src={element.imgIcon}
                        alt={element.label}
                      />
                    ) : null}
                    <span>{element.label}</span>
                  </div>
                ) : (
                  <Link
                    to={element.to ? element.to : '/'}
                    className='link-element'
                    onClick={toggleOpen}
                  >
                    {element.ReactIcon ? (
                      <element.ReactIcon
                        className='nav-icon'
                        color={
                          element.iconColor ? element.iconColor : '#6b3feb'
                        }
                      />
                    ) : element.imgIcon ? (
                      <img
                        className='nav-icon'
                        src={element.imgIcon}
                        alt={element.label}
                      />
                    ) : null}
                    <span>{element.label}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </OutsideAlerter>
  );
};

export default FloatingDropdown;
